export const BUCKETID = {
	"qa": {
		"2": 51,
		"3": 371,
		"7": 339,
		"12": 659,
		"13": 723,
		"15": 851,
		"16": 499,
		"17": 2569,
		"18": 403,
		"20": 11610,
		"22": 147,
		"26": 467,
		"34": 211,
		"36": 531,
		"38": 19,
		"33": 115,
		"45": 179,
		"44": 435,
		"8": 563,
		"9": 627,
		"27": 787
	},
	"prod": {
		"2": 51,
		"3": 371,
		"7": 339,
		"12": 659,
		"13": 723,
		"15": 851,
		"16": 499,
		"17": 2569,
		"18": 403,
		"20": 11610,
		"22": 147,
		"26": 467,
		"34": 211,
		"36": 531,
		"38": 19,
		"33": 115,
		"45": 179,
		"44": 435,
		"8": 563,
		"9": 627,
		"27": 787
	}
}